import React from 'react'
import { css } from '@emotion/react'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

import ProductsBar from './ProductsBar'

const bottomRowCss = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 4rem;
  gap: 3rem;

  p {
    font-size: 1.125rem;
    line-height: 1.3;
    font-weight: 400;
  }

  ${mediaQueries.mediumScreen()} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
  }
`

const BottomRow = () => {
  const year = new Date().getFullYear()

  return (
    <div css={bottomRowCss}>
      <p>&copy; {year} Text. All rights reserved.</p>
      <ProductsBar />
    </div>
  )
}

export default BottomRow
